import { createReducer, on } from '@ngrx/store';
import * as CalendarsPartnerActions from './calendars-partner.actions';
import { PartnerResponseCommercial } from 'src/app/pages/orders/interfaces/partnerCommercial.interface';

export type CalendarsPartnerCachedValue = PartnerResponseCommercial | unknown[];

export interface CalendarsPartnerState {
  response: { [key: string]: any };
  error: { [key: string]: any };
  loading: { [key: string]: boolean };
  cache: { [key: string]: CalendarsPartnerCachedValue };
}

export const initialState: CalendarsPartnerState = {
  response: {},
  error: {},
  loading: {},
  cache: {},
};

export const calendarsPartnerReducer = createReducer(
  initialState,
  on(CalendarsPartnerActions.getCalendarsPartner, (state, { key }) => ({
    ...state,
    loading: { ...state.loading, [key]: true },
    error: { ...state.error, [key]: null },
  })),
  on(CalendarsPartnerActions.setCalendarsPartnerEmptyCache, (state, { key, response }) => ({
    ...state,
    cache: { ...state.cache, [key]: response },
    loading: { ...state.loading, [key]: true },
    error: { ...state.error, [key]: null },
  })),
  on(CalendarsPartnerActions.getCalendarsPartnerSuccess, (state, { key, response }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    response: { ...state.response, [key]: response },
    cache: { ...state.cache, [key]: response },
    error: { ...state.error, [key]: null },
  })),
  on(CalendarsPartnerActions.getCalendarsPartnerFailure, (state, { key, error }) => ({
    ...state,
    loading: { ...state.loading, [key]: false },
    cache: (() => {
      const { [key]: _removed, ...rest } = state.cache;
      return rest;
    })(),
    error: { ...state.error, [key]: error },
  })),
  on(CalendarsPartnerActions.resetCalendarsPartner, () => initialState),
);
